import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=33fba7c0&scoped=true&"
import script from "./Offers.vue?vue&type=script&lang=ts&"
export * from "./Offers.vue?vue&type=script&lang=ts&"
import style0 from "./Offers.vue?vue&type=style&index=0&id=33fba7c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fba7c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33fba7c0')) {
      api.createRecord('33fba7c0', component.options)
    } else {
      api.reload('33fba7c0', component.options)
    }
    module.hot.accept("./Offers.vue?vue&type=template&id=33fba7c0&scoped=true&", function () {
      api.rerender('33fba7c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Offers.vue"
export default component.exports